module.exports = __webpack_public_path__ + "img/1481077860.9289d845.jpg";